export const setGiveawayLandingVariantColorTypeCreator = storePrefix => `${storePrefix}_SET_GIVEAWAY_LANDING_VARIANT_COLOR`;
export const setGiveawayLandingVariantColorActionFactory = storePrefix => ({
  productId,
  color,
  isOneProduct
}) => ({
  type: setGiveawayLandingVariantColorTypeCreator(storePrefix),
  payload: {
    productId,
    color,
    isOneProduct
  }
});
export const setGiveawayLandingVariantSizeTypeCreator = storePrefix => `${storePrefix}_SET_GIVEAWAY_LANDING_VARIANT_SIZE`;
export const setGiveawayLandingVariantSizeActionFactory = storePrefix => (productId, size, isOneProduct) => ({
  type: setGiveawayLandingVariantSizeTypeCreator(storePrefix),
  payload: {
    productId,
    size,
    isOneProduct
  }
});